import { useSaveData } from '@entities/common/savedData/index.ts';
import React, { useCallback } from 'react';
import { xhr } from '@shared/config';
import { usePopup } from '@shared/hooks';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { programsApi } from '@src/entities/programs';
import { useCertificateMessage } from 'library/hooks/common';

export const useProgramBuy = () => {
  const { module } = useModuleByCodeParam();
  const { popup } = usePopup();

  const [isProcessing, setIsProcessing] = React.useState(false);
  const { onRedirect } = useCertificateMessage();

  const buyProgram = async (id: number | string) => {
    setIsProcessing(true);
    try {
      const response = await xhr.get(`${programsApi}${id}/buy/`);

      if (response.data.redirect_url) {
        return response.data.redirect_url;
      }

      if (response.data.message) {
        window.location.href = `/programs/${module?.code}/program/${id}`;
      }
    } catch (error) {
      console.error(error);
      popup({ text: 'Оплата недоступна в данный момент', type: 'error' });
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    buyProgram: (id: number | string) => onRedirect(() => buyProgram(id)),
    isProcessing,
  };
};

export const useProgramModalBuyState = (programId?: number) => {
  const { data, doRemoveStorageData, doSetStorageData } = useSaveData<{
    isOpen: boolean;
    programId?: number;
  }>('programModalBuy');

  const doCloseModal = useCallback(() => doRemoveStorageData(), [doRemoveStorageData]);

  const doOpenModal = useCallback(() => {
    if (programId) {
      doSetStorageData({ isOpen: true, programId });
    }
  }, [programId, doSetStorageData]);

  return {
    modalState: data,
    doCloseModal,
    doOpenModal,
  };
};
